import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { link } from '../../../modules/analytics/actions';
import Translation from '../../i18n/Translation';
import { SHOP_LOCATOR } from '../../../routes/externalLinks';
import contentStackImageUrls from '../../../../resources/contentStackImageUrls.json';

const { shopBanner, plusCardSmall } = contentStackImageUrls;

export const WhatNextBanner = ({ clickLink }) => (
  <div>
    <div className="withdraw-result__banner">
      <h2 className="withdraw-result__banner-header">
        <Translation section="withdraw" label="successWhatNextTitle" />
      </h2>
      <p className="withdraw-result__banner-content">
        <Translation section="withdraw" label="successWhatNextContent" />
      </p>
      <div className="withdraw-result__banner-icons">
        <img
          className="withdraw-result__banner-icon"
          src={plusCardSmall}
          onError={(e) => { e.target.src = '../../../../assets/images/plus-card-small.png'; }}
          alt="Plus card"
        />
        <i className="material-icon material-icon--arrow-forward withdraw-result__banner-arrow" />
        <img
          className="withdraw-result__banner-icon"
          src={shopBanner}
          onError={(e) => { e.target.src = '../../../../assets/images/williamhill-logo-shadow.png'; }}
          alt="Plus card"
        />
      </div>
      <p className="withdraw-result__banner-footer">
        <a
          className="withdraw-result__link"
          href={SHOP_LOCATOR}
          target="blank"
          onClick={() => {
            clickLink({ path: SHOP_LOCATOR, name: 'FindYourNearestShop', source: 'WithdrawResult' });
          }}
        >
          <Translation section="withdraw" label="findNearestShop" />
        </a>
      </p>
    </div>
    <p className="withdraw-result__banner-note">
      <Translation section="withdraw" label="successWhatNextNote" />
    </p>
  </div>
);

WhatNextBanner.propTypes = {
  clickLink: PropTypes.func.isRequired
};

const mapDispatchToProps = {
  clickLink: link
};

export default connect(null, mapDispatchToProps)(WhatNextBanner);
